module.exports = __webpack_public_path__ + "img/data2-1.65845b7d.png";